import React from "react";
import { useSelector } from "react-redux";
import ArticleCard from "./ArticleCard";
export default function BusinessVisit() {
  // const { articles } = useSelector((state) => state.news);
  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          post.status === "published" &&
          post.slug !== "gioi-thieu" &&
          post.slug !== "dieu-khoan" &&
          post.category?.name === "Thăm doanh nghiệp"
      )
      ?.filter((e) => e.type !== "notification")
  );

  return (
    <div className="container mx-auto pt-2">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {posts?.slice(0, 3)?.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
